export default (conversionLengthInMinutes) => {
  switch (true) {
    case conversionLengthInMinutes < 1:
      return '1 minute';
    case conversionLengthInMinutes < 5:
      return '5 minutes';
    case conversionLengthInMinutes < 15:
      return '15 minutes';
    case conversionLengthInMinutes < 30:
      return '30 minutes';
    case conversionLengthInMinutes < 60:
      return '1 hour';
    default:
      return '1+ hours';
  }
};
